// extracted by mini-css-extract-plugin
export default {"sidebarImage":"Sidebar_sidebarImage__0qKl6"};